<div class="change-email-card">
  <button
    type="button"
    class="card-toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
  >
    <div class="toggle-left">
      <app-icon [type]="IconType.MAIL" [size]="20"></app-icon>
      <span class="toggle-title">Login-E-Mail ändern</span>
    </div>
    <app-icon
      [type]="IconType.CHEVRON_DOWN"
      [size]="20"
      [class.rotated]="isExpanded()"
    ></app-icon>
  </button>

  @if (isExpanded()) {
    <form [formGroup]="emailForm" (ngSubmit)="onSubmit()" class="email-form">
      @if (currentEmail) {
        <p class="current-email-hint">
          Aktuelle E-Mail: <strong>{{ currentEmail }}</strong>
        </p>
      }

      <div class="form-group">
        <label for="newEmail" class="form-label">Neue E-Mail-Adresse</label>
        <input
          type="email"
          id="newEmail"
          formControlName="email"
          class="form-input"
          autocomplete="email"
          placeholder="neue.adresse@beispiel.de"
        />
        @if (hasError('email', 'required')) {
          <span class="error-text">E-Mail-Adresse ist erforderlich</span>
        }
        @if (hasError('email', 'email')) {
          <span class="error-text">Bitte eine gültige E-Mail-Adresse eingeben</span>
        }
      </div>

      <div class="form-group">
        <label for="currentPasswordForEmail" class="form-label">Aktuelles Passwort</label>
        <div class="password-input-wrapper">
          <input
            [type]="showCurrentPassword() ? 'text' : 'password'"
            id="currentPasswordForEmail"
            formControlName="currentPassword"
            class="form-input"
            autocomplete="current-password"
            placeholder="Aktuelles Passwort eingeben"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="showCurrentPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
            [attr.aria-pressed]="showCurrentPassword()"
          >
            <app-icon
              [type]="showCurrentPassword() ? IconType.EYE_OFF : IconType.EYE"
              [size]="18"
            ></app-icon>
          </button>
        </div>
        @if (hasError('currentPassword', 'required')) {
          <span class="error-text">Aktuelles Passwort ist erforderlich</span>
        }
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="toggleExpanded()"
          [disabled]="isSaving()"
        >
          Abbrechen
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!emailForm.valid || isSaving()"
          [class.btn-loading]="isSaving()"
        >
          @if (isSaving()) {
            Speichern...
          } @else {
            E-Mail ändern
          }
        </button>
      </div>
    </form>
  }
</div>
